import { gql, useMutation } from '@apollo/client';
import { useGeneralSoContext } from 'src/common/context';
import type { FinishPaymentMutation, FinishPaymentMutationVariables, WsPayResp } from '../types/types';

export const finishPayment = gql`
  mutation FinishPayment($offerId: String!, $wsPayParams: WsPayResp!) {
    finishPayment(offerId: $offerId, wsPayParams: $wsPayParams) {
      success
      alreadyPaid
      message
      policyNumber
    }
  }
`;

export const recordPaymentError = gql`
  mutation RecordPaymentError($offerId: String!, $errorCode: String!, $errorMessage: String!) {
    recordPaymentError(offerId: $offerId, errorCode: $errorCode, errorMessage: $errorMessage)
  }
`;

export function useFinishPayment() {
  const { offerId } = useGeneralSoContext();
  const [mutation, info] = useMutation<FinishPaymentMutation, FinishPaymentMutationVariables>(finishPayment);

  const finishPaymentForOffer = async (wsPayParams: WsPayResp) => {
    if (!offerId) {
      throw new Error('Offer ID is required');
    }
    const { data } = await mutation({
      variables: { offerId, wsPayParams },
    });
    return data;
  };

  return [finishPaymentForOffer, info] as const;
}
